<template>
  <div class="workouts-slider-wrapper section-padding">
    <div class="container" v-if="showChallengesSlider">
      <div class="workouts-slider-holder">
        <div class="workouts-slider-heading d-flex justify-content-between align-items-center">
          <p class="section-title">Desafios</p>
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/challenges-list" class="heading-link">Ver todos</router-link>
            <div class="workouts-slider-arrows d-none d-xl-flex align-items-center justify-content-center">
              <button type="button" class="workouts-slider-arrow workouts-slider-prev" @click="prevSlide">
                <chevronLeft/>
              </button>
              <button type="button" class="workouts-slider-arrow workouts-slider-next" @click="nextSlide">
                <chevronLeft/>
              </button>
            </div>
          </div>
        </div>
        <Slick ref="slick" :options="slickOptions" class="workouts-slider">
          <div class="workouts-slider-item"  v-for="(item,index) in challengesSliderItems" :key="index">
            <challengeItem :challengeItem="item" />
          </div>
        </Slick>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import challengeItem from "@/components/challenges/challenge-item.vue";
import chevronLeft from "@/components/svg/chevron-left.vue";
import axios from 'axios';

export default {
  name: "challenges-slider",
  components : {
    Slick,
    challengeItem,
    chevronLeft
  },
  data() {
    return {
      lang: this.$root.siteLang,
      challengesSliderItems: [],
      showChallengesSlider: false,
      slickOptions: {
        slidesToScroll: 1,
        pauseOnHover: true,
        autoplay: true,
        arrows: false,
        dots: false,
        infinite: true,
        swipeToSlide: true,
        touchMove: true,
        speed: 1000,
        variableWidth: true
      }
    }
  },
  methods: {
    prevSlide: function() {
      this.$refs.slick.prev();
    },
    nextSlide: function() {
      this.$refs.slick.next();
    },
  },
  created() {
    let authKey = window.$cookies.get("authKey");

    axios
        .get(process.env.VUE_APP_API_URL + 'products?id_category=4&lang=' + this.lang,{
          headers: {
            Authorization: 'Bearer ' + authKey
          }
        })
        .then((response) => {
          this.challengesSliderItems = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        }).finally((e) => {
      (this.challengesSliderItems.length > 0) ? this.showChallengesSlider = true : this.showChallengesSlider = false;
    });
  },
}
</script>